export default [
    {
        name: "Accueil",
        route: "/dashboard",
        icon: "grid-01",
        acl: [],
        scope: null
    },
    {
        name: "Calendrier",
        route: "/reservation",
        icon: "calendar",
        acl: [['weeboxcore.schedule.vue']],
        scope: null
    },
    {
        name: "Facturation",
        route: "/invoicing/invoice",
        icon: "file-06",
        acl: [['weeboxcore.invoice.vue']],
        scope: null,
        children: [
            {
                route: 'invoicing-dashboard',
                name: 'Dashboard',
                acl: []
            },
            {
                route: 'invoice',
                name: 'Factures',
                acl: [['weeboxcore.invoice.view']]
            }
        ]
    },
    {
        name: "e-commerce",
        route: "/shop/order",
        icon: "shopping-bag-01",
        acl: [
            ['weeboxshop.order.vue'],
            ['weeboxshop.brand.vue'],
            ['weeboxshop.category.vue'],
            ['weeboxshop.discount.vue'],
            ['weeboxshop.inventory.vue'],
            ['weeboxshop.product.vue'],
            ['weeboxshop.producttype.vue'],
            ['weeboxshop.shipping.vue'],
            ['weeboxshop.voucher.vue']
        ],
        scope: null,
        notice: 4,
        children: [
            {
                route: 'shop-dashboard',
                name: 'Dashboard',
                acl: [['weeboxshop.order.vue']]
            },
            {
                route: 'order',
                name: 'Commandes',
                acl: [['weeboxshop.order.vue']]
            },
            {
                route: 'category',
                name: 'Catégories',
                acl: [['weeboxshop.category.vue']]
            },
            {
                route: 'category-tree',
                name: 'Arbre des catégories',
                acl: [['weeboxshop.category.vue']]
            },
            {
                route: 'product',
                name: 'Produits',
                acl: [['weeboxshop.product.vue']]
            },
            {
                route: 'inventory',
                name: 'Inventaire',
                acl: [['weeboxshop.inventory.vue']]
            },
            {
                route: 'voucher',
                name: 'Code rabais',
                acl: [['weeboxshop.voucher.vue']]
            },
            {
                route: 'discount',
                name: 'Promotions',
                acl: [['weeboxshop.discount.vue']]
            },
            {
                route: 'giftcard',
                name: 'Bon cadeau',
                acl: [['weeboxshop.giftcard.vue']]
            },
            {
                route: 'commercial-gesture',
                name: 'Gestes commerciaux',
                acl: [['weeboxshop.commercialgesture.vue']]
            },
            {
                route: 'brand',
                name: 'Marques',
                acl: [['weeboxshop.brand.vue']]
            },
            {
                route: 'product-type',
                name: 'Types',
                acl: [['weeboxshop.producttype.vue']]
            },
            {
                route: 'product-option',
                name: 'Options',
                acl: [['weeboxshop.productoption.vue']]
            },
            {
                route: 'shipping',
                name: 'Livraisons',
                acl: [['weeboxshop.shipping.vue']]
            },
        ]
    },
    {
        name: "Contacts",
        route: "/contacts/person",
        icon: "users-01",
        acl: [['weeboxcore.person.vue'], ['weeboxcore.company.vue'], ['weeboxcore.person.vue', 'weeboxcore.company.vue']],
        notice: 2,
        scope: null,
        children: [
            {
                route: 'contacts-dashboard',
                name: 'Dashboard',
                acl: []
            },
            {
                route: 'person',
                name: 'Particuliers',
                acl: [['weeboxcore.person.view']]
            },
            {
                route: 'company',
                name: 'Entreprises',
                acl: [['weeboxcore.company.view']]
            }
        ]
    },
    {
        name: "Evénements",
        route: "/event",
        icon: "calendar-date",
        acl: [['weeboxcore.event.vue']],
        scope: null
    },
    {
        name: "Campagnes",
        route: "/campaign",
        icon: "send-01",
        acl: [['weeboxcore.campaign.vue']],
        scope: null,
        children: [
            {
                route: 'campaign-dashboard',
                name: 'Dashboard',
                acl: []
            },
            {
                route: 'audience',
                name: 'Audience',
                acl: []
            },
            {
                route: 'campaign',
                name: 'Campagnes',
                acl: [['weeboxcore.campaign.vue']]
            },
            /*
          {
            route: 'template',
            name: 'Templates',
            acl: [['weeboxcore.campaign.vue']]
          },
             */
        ]
    },
    {
        name: "Contrats",
        route: "/serevita",
        icon: "file-01",
        acl: [['weeboxserevita.contract.vue']],
        scope: ['serevita'],
        children: [
            {
                route: 'serevita-dashboard',
                name: 'Dashboard',
                acl: []
            },
            {
                route: 'contract',
                name: 'Contrats',
                acl: [['weeboxserevita.contract.view']]
            },
            {
                route: 'protractor',
                name: 'Apporteur d\'affaire',
                acl: [['weeboxserevita.protractor.view']]
            },
            {
                route: 'protractor-link',
                name: 'Affaires rapportées',
                acl: [['weeboxserevita.protractorlink.view']]
            },
            {
                route: 'table',
                name: 'Liste de prix',
                acl: [['weeboxserevita.table.view']]
            }
        ]
    },
    {
        name: "Media",
        route: "/media",
        icon: "image-01",
        acl: [['weeboxcore.media.vue']],
        scope: null
    },
    {
        name: "QR Code",
        route: "/shortlink",
        icon: "qr-code-02",
        acl: [['weeboxcore.shortlink.vue']],
        scope: null
    },
    {
        name: "Config",
        route: "/config/scope",
        icon: "settings-03",
        acl: [['weeboxcore.attribute.view'], ['weeboxcore.transporter.view'], ['weeboxcore.payment.view'], ['weeboxcore.paymentCondition.view'], ['weeboxcore.invoice-template.view'], ['weeboxcore.pdf-template.view'], ['weeboxcore.tax.view'], ['weeboxcore.scope.view'], ['weeboxcore.branch.view'], ['weeboxcore.slotable.vue'], ['weeboxcore.scopeopeninghour.vue'], ['weeboxcore.schedule.view']],
        scope: null,
        children: [
            {
                route: 'attribute',
                name: 'Attributes',
                acl: [['weeboxcore.attribute.view']]
            },
            {
                route: 'transporter',
                name: 'Transporteurs colis',
                acl: [['weeboxcore.transporter.view']]
            },
            {
                route: 'payment',
                name: 'Méthodes de paiements',
                acl: [['weeboxcore.payment.view']]
            },
            {
                route: 'payment-condition',
                name: 'Conditions de paiement',
                acl: [['weeboxcore.paymentCondition.view']]
            },
            {
                route: 'invoice-template',
                name: 'Template de facture',
                acl: [['weeboxcore.invoice-template.view']]
            },
            {
                route: 'pdf-template',
                name: 'Template PDF',
                acl: [['weeboxcore.pdf-template.view']]
            },
            {
                route: 'tax',
                name: 'Taxes',
                acl: [['weeboxcore.tax.view']]
            },
            {
                route: 'tag',
                name: 'Tags',
                acl: [['weeboxcore.tag.view']]
            },
            {
                route: 'scope',
                name: 'Scopes',
                acl: [['weeboxcore.scope.view']]
            },
            {
                route: 'branch',
                name: 'Succursales',
                acl: [['weeboxcore.branch.view']]
            },
            {
                route: 'calendar',
                name: 'Calendrier',
                acl: [['weeboxcore.slotable.vue']]
            },
            {
                route: 'opening-hours',
                name: 'Horaires',
                acl: [['weeboxcore.scopeopeninghour.vue']]
            },
            {
                route: 'agenda',
                name: 'Horaires (BETA)',
                acl: [['weeboxcore.agenda.vue']]
            },
            {
                route: 'closure',
                name: 'Vacances / fermeture',
                acl: [['weeboxcore.schedule.view']]
            },
            {
                route: 'acl',
                name: 'Authorizations',
                acl: [['is_super_admin']]
            },
            {
                route: 'queue',
                name: 'Logs',
                acl: [['is_super_admin']]
            }
        ]
    },
]



// WEBPACK FOOTER //
// ./src/navigation.js